import { css, keyframes } from 'styled-components';
import { getBaseTheme } from '@Themes';

const { texts, spaces, colors } = getBaseTheme();

const fadeIn = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;
const explode = keyframes`
    30% {
      stroke-width: 3;
      stroke-opacity: 1;
      transform: scale(0.8) rotate(40deg);
    }
  
    100% {
      stroke-width: 0;
      stroke-opacity: 0;
      transform: scale(1.1) rotate(60deg);
    }
`;

export default css`
    z-index: 1;
    flex-grow: 1;

    .inline-checkbox-svg {
        width: 40%;
        position: absolute;
        z-index: -1;
        opacity: 0;
    }

    .status {
        display: block;
        opacity: 0;
        position: relative;
        padding: ${spaces.default.xs} ${spaces.default.s} ${spaces.default.xs} 16%;
        margin: 0 auto;
        cursor: pointer;

        &-text {
            transition: all 0.4s linear 0.4s;
            opacity: 0.5;
        }

        &-list {
            font-size: ${texts.sizes.m.fontSize};
            line-height: ${texts.sizes.m.lineHeight};
            max-width: 22rem;
            margin: 10% auto;
            padding: 0em ${spaces.default.xs};
            pointer-events: none;
        }

        &-state {
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0;

            &:checked ~ .status-text {
                transition-delay: 0s;
            }

            &:checked ~ .status-icon .status-box {
                stroke-dashoffset: 56.1053;
                transition-delay: 0s;
            }

            &:checked ~ .status-icon .status-check {
                stroke-dashoffset: 0;
                transition-delay: 0.48s;
            }

            &:checked ~ .status-icon .status-circle {
                animation-name: ${explode};
            }
        }

        &-icon {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            width: 100%;
            height: auto;
            margin: auto;
            fill: none;
            stroke: ${colors.area.default.foregroundColor};
            stroke-width: 2;
            stroke-linejoin: round;
            stroke-linecap: round;
        }

        &-box {
            stroke-dasharray: 56.1053, 56.1053;
            stroke-dashoffset: 0;
            transition-delay: 0.16s;
        }

        &-check {
            stroke: ${colors.area.default.foregroundColor};
            stroke-dasharray: 9.8995, 9.8995;
            stroke-dashoffset: 9.8995;
            transition-duration: 0.32s;
        }

        &-box,
        &-check {
            transition: stroke-dashoffset 0.8s cubic-bezier(0.9, 0, 0.5, 1);
        }

        &-circle {
            stroke: ${colors.area.default.foregroundColor};
            stroke-dasharray: 1 6;
            stroke-width: 0;
            transform-origin: 13.5px 12.5px;
            transform: scale(0.4) rotate(0deg);
            animation: none 0.8s linear;
        }

        &-circle {
            animation-delay: 0.56s;
            animation-duration: 0.56s;
        }
    }

    .fade-in {
        animation: ${fadeIn};
        animation-duration: 0.5s;
        animation-timing-function: ease;
        animation-fill-mode: forwards;
    }

    .status-active .status-text {
        color: ${colors.area.default.foregroundColor};
        font-weight: 800;
        opacity: 1;
    }
`;
